// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs'
import { getCookie } from 'cookies-next'
import getConfig from 'next/config'

const { publicRuntimeConfig } = getConfig()

Sentry.init({
  dsn: publicRuntimeConfig.NEXT_PUBLIC_SENTRY_DSN,
})

Sentry.configureScope(function (scope) {
  scope.setTag('ssr', false)

  const userId = getCookie(process.env.NEXT_PUBLIC_USER_ID_COOKIE_NAME)

  if (userId) {
    scope.setUser({
      id: userId,
    })
  }
})
